import { createBrowserHistory } from 'history';
import frontendAnalyticsPage from '../analytics/util/frontendAnalyticsPage';

const history = createBrowserHistory();

history.listen((location) => {
  if (!location) {
    return;
  }

  frontendAnalyticsPage(location);
});

export default history;
